import { ActionContext, Module } from 'vuex'
import shop from '../../api/shop'
import { PRODUCTS } from '../mutation-types'
import { Product } from '@/interfaces/product'
import { RootState } from '@/store/interfaces'
import { ProuductModuleState } from '@/store/modules/interfaces'

// initial state
const state: ProuductModuleState = {
  all: []
}

const getters = {}

const actions = {
  getAllProducts({ commit }: ActionContext<ProuductModuleState, RootState>) {
    //模拟异步操作 放在actions里面然后调用commit来调用mutations里面的方法来改变state中的数据
    shop.getProducts(products => {
      commit(PRODUCTS.SET_PRODUCTS, products)
    })
  }
}

const mutations = {
  //mutations中的将参数直接赋值给state中的all变量
  [PRODUCTS.SET_PRODUCTS](state: ProuductModuleState, products: Product[]) {
    state.all = products
  },
  //根据参数来判断当前的all数据中是否有该id的数据，如果有的话直接将当前的产品的inventory数量减1
  [PRODUCTS.DECREMENT_PRODUCT_INVENTORY](
    state: ProuductModuleState,
    { id }: any
  ) {
    const product = state.all.find(product => product.id == id)
    if (product) {
      product.inventory = product.inventory - product.canAdd
      product.canAdd = 0
    }
  },
  //减一的时候调用的mutation
  [PRODUCTS.PRODUCT_ADDCANNUMBER](state: ProuductModuleState, id: any) {
    const product = state.all.find(product => product.id == id)
    product && product.canAdd++
  },
  //加一的时候调用的mutation
  [PRODUCTS.PRODUCT_DESCANNUMBER](state: ProuductModuleState, id: any) {
    const product = state.all.find(product => product.id == id)
    product && product.canAdd--
  }
}

//将所有集合成一个对象返回出去，并且加上参数namespaced 是true
const proudctModule: Module<ProuductModuleState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
export default proudctModule
